import React, { useState, useEffect, useCallback, useContext } from "react";
import { Button, Input, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Header from "../../layout/Header/Header";
import { posGet, posPost, posPatch, avisaError, avisaOk } from "./posApi";
import { AuthContext } from "../../contexts/AuthContext";
import SinPermiso from "./SinPermiso";

const VACIA = { name: "", clave: "", direccion: "", telefono: "", is_active: "Si" };

function PosTiendas() {
  const { user } = useContext(AuthContext);
  const [tiendas, setTiendas] = useState([]);
  const [form, setForm] = useState(null);
  const [texto, setTexto] = useState("");

  const cargar = useCallback(() => { posGet("/tiendas").then(setTiendas).catch(avisaError); }, []);
  useEffect(() => { cargar(); }, [cargar]);

  const guardar = async () => {
    try {
      if (form._id) await posPatch(`/tiendas/${form._id}`, form);
      else await posPost("/tiendas", form);
      avisaOk("Tienda guardada");
      setForm(null);
      cargar();
    } catch (e) { avisaError(e); }
  };

  const vis = tiendas.filter((t) => `${t.clave || ""} ${t.name} ${t.direccion || ""}`.toLowerCase().includes(texto.toLowerCase()));

  if (!(user && user.rolTiendas === "master" && user.posTiendas)) return <SinPermiso que="administrar tiendas" />;

  return (
    <>
      <Header />
      <div className="card container col-12" style={{ padding: "18px 22px" }}>
        <div className="page-header">
          <div>
            <h3 className="page-title"><i className="fas fa-store mr-2" style={{ color: "#10b981" }} />Tiendas</h3>
            <p className="page-subtitle">{tiendas.filter((t) => t.is_active === "Si").length} tiendas activas · la clave sale en los folios del ticket</p>
          </div>
          <div className="page-actions">
            <Button color="success" onClick={() => setForm({ ...VACIA })}><i className="fas fa-plus mr-1" />Nueva tienda</Button>
            <Button color="secondary" size="sm" href="/PuntoVenta"><i className="fas fa-th-large mr-1" />Menú</Button>
          </div>
        </div>
        <div className="filter-bar"><div style={{ flex: 1 }}><label>Buscar</label><Input value={texto} onChange={(e) => setTexto(e.target.value)} placeholder="Clave, nombre o dirección" /></div></div>
        <div className="table-responsive">
          <table className="table table-sm table-dark-header">
            <thead><tr><th>Clave</th><th>Tienda</th><th>Dirección</th><th>Teléfono</th><th>Estado</th><th /></tr></thead>
            <tbody>
              {!vis.length && <tr><td colSpan={6} className="text-center text-muted py-4">Sin tiendas</td></tr>}
              {vis.map((t) => (
                <tr key={t._id} style={t.is_active === "No" ? { color: "#94a3b8" } : {}}>
                  <td>{t.clave}</td><td><strong>{t.name}</strong></td><td>{t.direccion}</td><td>{t.telefono}</td>
                  <td>{t.is_active === "Si" ? <span className="badge badge-success">Activa</span> : <span className="badge badge-secondary">Inactiva</span>}</td>
                  <td><Button size="sm" color="info" onClick={() => setForm({ ...VACIA, ...t })}><i className="fas fa-pen" /></Button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal isOpen={!!form} toggle={() => setForm(null)}>
        <ModalHeader toggle={() => setForm(null)}>{form && form._id ? "Editar tienda" : "Nueva tienda"}</ModalHeader>
        {form && (
          <ModalBody>
            <div className="row">
              <div className="col-4 mb-3"><label>Clave</label><Input value={form.clave} placeholder="T01" onChange={(e) => setForm({ ...form, clave: e.target.value.toUpperCase() })} /></div>
              <div className="col-8 mb-3"><label>Nombre</label><Input value={form.name} placeholder="Plaza Satélite" onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
              <div className="col-12 mb-3"><label>Dirección (sale en el ticket)</label><Input value={form.direccion} onChange={(e) => setForm({ ...form, direccion: e.target.value })} /></div>
              <div className="col-6 mb-3"><label>Teléfono</label><Input value={form.telefono} onChange={(e) => setForm({ ...form, telefono: e.target.value })} /></div>
              {form._id && (
                <div className="col-6 mb-3"><label>Estado</label>
                  <Input type="select" value={form.is_active} onChange={(e) => setForm({ ...form, is_active: e.target.value })}>
                    <option value="Si">Activa</option><option value="No">Inactiva</option>
                  </Input>
                </div>
              )}
            </div>
          </ModalBody>
        )}
        <ModalFooter>
          <Button color="secondary" onClick={() => setForm(null)}>Cancelar</Button>
          <Button color="success" onClick={guardar}>Guardar</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default PosTiendas;
